import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Zap } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { NodeVisualDefinition, TriggerNode } from '../../types';

import {
  BusinessEventTriggerConfigType,
  getBusinessEventTriggerPreviewText,
} from './schema';

/** Typed node for business event trigger */
type BusinessEventTriggerNodeType = TriggerNode<BusinessEventTriggerConfigType>;

/** Visual definition for the Business Event Trigger node */
export const businessEventTriggerVisualDefinition: NodeVisualDefinition = {
  key: 'BusinessEventTrigger',
  label: 'Business Event',
  description: 'Trigger when a specific business event occurs',
  icon: Zap,
  color: 'warning',
  handles: [
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getBusinessEventTriggerPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Business Event Trigger nodes on the canvas.
 */
export const BusinessEventTriggerNode = React.memo<
  NodeProps<BusinessEventTriggerNodeType>
>((props) => (
  <BaseNode
    {...props}
    definition={businessEventTriggerVisualDefinition}
    className="@BusinessEventTriggerNode"
  />
));

BusinessEventTriggerNode.displayName = 'BusinessEventTriggerNode';
